import { useEffect } from "react";
import { DEEP_LINK } from "@/lib/nativeAuth";

/**
 * Served on the live site as /auth/native. Emergent auth redirects here with
 * #session_id=…; we hand that straight to the native app via its URL scheme.
 */
export default function NativeAuthBridge() {
  useEffect(() => {
    const hash = window.location.hash || "";
    window.location.replace(hash.includes("session_id=") ? `${DEEP_LINK}${hash}` : DEEP_LINK);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg px-6" data-testid="native-auth-bridge">
      <div className="text-center">
        <div className="w-10 h-10 rounded-full border-2 border-brand border-t-transparent animate-spin mx-auto" />
        <p className="mt-4 text-muted2 font-display">Returning you to Ikavio…</p>
        <a href={DEEP_LINK} className="text-brand text-sm hover:underline mt-3 inline-block" data-testid="native-auth-open-app">
          Open the Ikavio app
        </a>
      </div>
    </div>
  );
}
